import React from 'react';

const ShadowBtn = ({ className = '', text = '', onClick = () => {} }) => {
  return (
    <button
      className={`${className} fredoka mx-auto flex h-12 w-[192px] items-center justify-center rounded-2xl bg-[#FC823E] px-6 py-2 text-base font-semibold leading-none text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset]`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default ShadowBtn;
